// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2YCxU","noInteraction":"EventWrapper_noInteraction__1Zhi0","pointerPassthrough":"EventWrapper_pointerPassthrough__1qguy"};